import React from 'react';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import NavBar from '../../../component/b2b/navBar/b2bNavBar';
import {
  FaEnvelope,
  FaWhatsapp,
  FaHeadset,
  FaClock,
  FaArrowRight,
  FaComments,
  FaPhoneAlt,
  FaMailBulk,
  FaRegClock,
  FaReplyAll,
  FaRocket
} from 'react-icons/fa';
import '../../../css/custom-scrollbar.css'

const B2bSupport = () => {
  const { isDarkMode, isToggleSidebar } = useMyContext();

  const supportChannels = [
    {
      icon: <FaEnvelope className="w-5 h-5" />,
      title: 'Email Support',
      description: 'Detailed responses within 24 hours for all your queries',
      contact: 'support@pickupxpress.com',
      link: 'mailto:support@pickupxpress.com',
      badge: '24 hrs',
      badgeColor: 'bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300',
      iconBg: 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300'
    },
    {
      icon: <FaWhatsapp className="w-5 h-5" />,
      title: 'WhatsApp Support',
      description: 'Instant messaging support for quick resolutions and real-time help',
      contact: '+91 XXXX XX 0087',
      link: 'https://wa.me/message/LCC4KAGD5JFUC1',
      badge: 'Instant',
      badgeColor: 'bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300',
      iconBg: 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300'
    }
  ];

  const quickLinks = [
    { icon: <FaComments className="w-3.5 h-3.5" />, label: 'Live Chat', desc: 'Chat with our team' },
    { icon: <FaPhoneAlt className="w-3.5 h-3.5" />, label: 'Call Back', desc: 'Request a call' },
    { icon: <FaReplyAll className="w-3.5 h-3.5" />, label: 'FAQ', desc: 'Common questions' },
    { icon: <FaRocket className="w-3.5 h-3.5" />, label: 'Guide', desc: 'Help center' },
  ];
 const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

  return (
 <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-gray-50'}`}>
      <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />

      <NavBar />
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div className={`w-64 m-3 rounded-3xl ${glass} overflow-hidden`}>
            <Sidebar />
          </div>
        )}


        <div className="flex-1 dark:bg-black p-4 md:p-5 w-full bg-gray-200 overflow-y-auto custom-scrollbar">

          <div className="max-w-5xl mx-auto">

            {/* Header */}
            <div className="flex-shrink-0 mb-5">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900">
                  <FaHeadset fill='blue' className="w-5 h-5 text-gray-700 dark:text-gray-300" />
                </div>
                <div>
                  <h1 className="text-base font-bold text-gray-800 dark:text-white tracking-tight">Support Center</h1>
                  <p className="text-[10px] text-gray-400 dark:text-gray-500">We're here to help with any questions or concerns</p>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-4">
              {quickLinks.map((link, idx) => (
                <div key={idx} className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3 text-center hover:shadow-sm transition-all cursor-pointer">
                  <div className="w-8 h-8 mx-auto rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center text-gray-600 dark:text-gray-400 mb-1.5">
                    {link.icon}
                  </div>
                  <p className="text-[10px] font-semibold text-gray-700 dark:text-gray-300">{link.label}</p>
                  <p className="text-[8px] text-gray-400 dark:text-gray-500">{link.desc}</p>
                </div>
              ))}
            </div>

            {/* Support Cards */}
            <div className="grid md:grid-cols-2 gap-3">
              {supportChannels.map((channel, index) => (
                <div
                  key={index}
                  className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-sm hover:shadow-md transition-all overflow-hidden group"
                >
                  <div className="p-4">
                    {/* Header */}
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-center gap-3">
                        <div className={`w-10 h-10 rounded-xl ${channel.iconBg} flex items-center justify-center`}>
                          {channel.icon}
                        </div>
                        <div>
                          <h3 className="text-[11px] font-bold text-gray-800 dark:text-white uppercase tracking-wider">
                            {channel.title}
                          </h3>
                          <span className={`text-[8px] font-medium px-2 py-0.5 rounded-full ${channel.badgeColor}`}>
                            {channel.badge}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Description */}
                    <p className="text-[10px] text-gray-500 dark:text-gray-400 leading-relaxed mb-3">
                      {channel.description}
                    </p>

                    {/* Contact */}
                    <div className="bg-gray-50 dark:bg-gray-800/50 rounded-lg px-3 py-2 mb-3">
                      <span className="text-[10px] font-mono font-medium text-gray-700 dark:text-gray-300">
                        {channel.contact}
                      </span>
                    </div>

                    {/* Button */}
                    <a
                      href={channel.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center w-full bg-red-600 dark:bg-white hover:opacity-85 text-white dark:text-gray-800 py-2 rounded-lg font-medium text-[10px] transition-all gap-2"
                    >
                      <span>Contact Support</span>
                      <FaArrowRight className="w-3 h-3" />
                    </a>
                  </div>
                </div>
              ))}
            </div>

            {/* Hours & Stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mt-3">
              <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3 flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center text-gray-600 dark:text-gray-400">
                  <FaClock fill='blue' className="w-3.5 h-3.5" />
                </div>
                <div>
                  <p className="text-[8px] text-gray-400 dark:text-gray-500 uppercase tracking-wider">Business Hours</p>
                  <p className="text-[10px] font-semibold text-gray-800 dark:text-white">Mon–Sat, 9:00 AM – 6:00 PM</p>
                </div>
              </div>
              <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3 flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center text-gray-600 dark:text-gray-400">
                  <FaRegClock fill='blue' className="w-3.5 h-3.5" />
                </div>
                <div>
                  <p className="text-[8px] text-gray-400 dark:text-gray-500 uppercase tracking-wider">Response Time</p>
                  <p className="text-[10px] font-semibold text-gray-800 dark:text-white">Within 24 hours</p>
                </div>
              </div>
              <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3 flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center text-gray-600 dark:text-gray-400">
                  <FaWhatsapp fill='green' className="w-3.5 h-3.5" />
                </div>
                <div>
                  <p className="text-[8px] text-gray-400 dark:text-gray-500 uppercase tracking-wider">WhatsApp Support</p>
                  <p className="text-[10px] font-semibold text-gray-800 dark:text-white">Available 24/7</p>
                </div>
              </div>
            </div>

          </div>
        </div>


      </div>
    </div>
  );
};

export default B2bSupport;